import {useContext} from "react";
import {OperationalSearchState} from "./OperationalSearchState";
import {OperationalSearchStateContext} from "./OperationalSearchStateProvider";

export function useOperationalSearchState(): OperationalSearchState {
  return useContext(OperationalSearchStateContext);
}
